import { defineStore } from "pinia";
import { ref } from "vue";

// import { v4 as uuidv4 } from 'uuid';


export const useSystemStore = defineStore('systemStore', () => {

    const deviceMemory = navigator.deviceMemory;
    const memorySample = ref(null);
    const memorySampleTimestamp = ref(0);
    const nextMemorySampleInSeconds = ref(0);
    const checkMemoryInterval = 5 * 60; // 5 minuti, in secondi
    const crossOriginIsolated = window.crossOriginIsolated;

    const usageMemoryPercent = ref(0)

    // PRESSURE
    const lastRecordPressure = ref({})
    const pressureSupported = ref(false)

    const pressureCallback = (records) => {
        lastRecordPressure.value = records[records.length - 1].toJSON()

        // console.log(lastRecordPressure.value)

        // console.log(`Current pressure ${lastRecordPressure.value.state}`);
        if (lastRecordPressure.value.state === "critical") {
            // disable video feeds
        } else if (lastRecordPressure.value.state === "serious") {
            // disable video filter effects
        } else {
            // enable all video feeds and filter effects
        }
    }

    const observePressure = async () => {

        if (!("PressureObserver" in window)) {
            // report that the API is not supported
            console.log("🧠 PressureObserver API is not supported in this browser.");
            return
        }
        pressureSupported.value = true
        try {
            const observer = new PressureObserver(pressureCallback);
            await observer.observe("cpu", {
                sampleInterval: 1000, // 1000ms
            });
        } catch (error) {
            // report error setting up the observer
        }
    }

    observePressure()





    // RAM

    const measureMemory = async () => {
        if (!performance?.measureUserAgentSpecificMemory) return
        memorySample.value = await performance.measureUserAgentSpecificMemory();
        memorySampleTimestamp.value = Date.now();
        usageMemoryPercent.value = Math.ceil((memorySample.value?.bytes / (deviceMemory * 1024 * 1024 * 1024)) * 100)
    }

    const setnextMemorySampleInSeconds = async () => {
        const now = Date.now();
        nextMemorySampleInSeconds.value = checkMemoryInterval - Math.floor((now - memorySampleTimestamp.value) / 1000);
    }


    if (crossOriginIsolated) {
        measureMemory()
        const interval = checkMemoryInterval * 1000; // 5 minuti
        setInterval(measureMemory, interval);
        setInterval(setnextMemorySampleInSeconds, 999);
    }

    // STORAGE

    const usageDetailsNotSupported = ref(false)


    const storagePersistent = ref({
        state: false,
        icon: "mdi-help",
        description: "desc",
    })

    const quota = ref({
        kB: 0,
        MB: 0,
        GB: 0,
        TB: 0,
    });


    const usageAmount = ref({
        caches: 0,
        indexedDB: 0,
        localStorage: encodeURIComponent(JSON.stringify(localStorage)).length,
        sessionStorage: encodeURIComponent(JSON.stringify(sessionStorage)).length,
    });




    const estimateSupported = !!navigator.storage?.estimate;


    const usageUnit = ref("kB");
    const quotaUnit = ref("kB");

    const usage = ref({
        percent: 0,
        kB: 0,
        MB: 0,
        GB: 0,
        TB: 0,
    });
    const calcUsage = () => {


        if (navigator.storage && navigator.storage.persist) {
            navigator.storage.persist().then(persistent => {
                if (persistent) {
                    // storagePersistentDescription.value = "Storage will not be cleared except by explicit user action" 
                    storagePersistent.value.description = 'La memoria di questo dispositivo è persistente: non verrà cancellata tranne che per azione esplicita dell\'utente.'
                    storagePersistent.value.state = true
                    storagePersistent.value.icon = 'mdi-check'
                } else {
                    // storagePersistentDescription.value = "Storage may be cleared by the UA under storage pressure." 
                    storagePersistent.value.description = 'La memoria di questo dispositivo non è persistente: potrebbe essere cancellata dal browser se in difetto di memoria.'
                    storagePersistent.value.state = false
                    storagePersistent.value.icon = 'mdi-close'
                }
            });

            if (estimateSupported)
                navigator.storage.estimate().then((estimate) => {  // ? for ios

                    // console.log("estimate.usage",estimate.usage)
                    // console.log("estimate.quota",estimate.quota)

                    if (!estimate?.usageDetails) {
                        usageDetailsNotSupported.value = true
                        return
                    }

                    usage.value.usageDetails = estimate.usageDetails

                    usageAmount.value.caches = BytesValueToHR(estimate.usageDetails.caches)
                    usageAmount.value.indexedDB = BytesValueToHR(estimate.usageDetails.indexedDB)

                    // console.log(usage.value.usageDetails)

                    usage.value.percent = Math.ceil((
                        (estimate.usage / estimate.quota) *
                        100
                    ))
                    usage.value.kB = (estimate.usage / 1024).toFixed(2);
                    usage.value.MB = (estimate.usage / 1024 / 1024).toFixed(2);
                    usage.value.GB = (estimate.usage / 1024 / 1024 / 1024).toFixed(2);
                    usage.value.TB = (estimate.usage / 1024 / 1024 / 1024 / 1024).toFixed(2);

                    quota.value.kB = (estimate.quota / 1024).toFixed(2)
                    quota.value.MB = (estimate.quota / 1024 / 1024).toFixed(2)
                    quota.value.GB = (estimate.quota / 1024 / 1024 / 1024).toFixed(2)
                    quota.value.TB = (estimate.quota / 1024 / 1024 / 1024 / 1024).toFixed(2)

                    // debugger

                    if (estimate.usage > 1024 ** 2 - 1) {
                        usageUnit.value = "MB";
                        if (estimate.usage > 1024 ** 3 - 1) {
                            usageUnit.value = "GB";
                            if (estimate.usage > 1024 ** 4 - 1) {
                                usageUnit.value = "TB";
                            }
                        }
                    }


                    if (estimate.quota > 1024 ** 2 - 1) {
                        quotaUnit.value = "MB";
                        if (estimate.quota > 1024 ** 3 - 1) {
                            quotaUnit.value = "GB";
                            if (estimate.quota > 1024 ** 4 - 1) {
                                quotaUnit.value = "TB";
                            }
                        }
                    }
                });
        }
    }


    calcUsage()


    const BytesValueToHR = (value) => {

        if (!value) return "-"

        if (value > 1024 ** 4 - 1) {
            return (value / 1024 / 1024 / 1024 / 1024).toFixed(2) + " TB";
        } else if (value > 1024 ** 3 - 1) {
            return (value / 1024 / 1024 / 1024).toFixed(2) + " GB";
        } else if (value > 1024 ** 2 - 1) {
            return (value / 1024 / 1024).toFixed(2) + " MB";
        } else if (value > 1024 ** 1 - 1) {
            return (value / 1024).toFixed(2) + " kB";
        } else {
            return value + " B";
        }
    }


    return {

        lastRecordPressure,
        pressureSupported,

        deviceMemory,
        memorySample,
        memorySampleTimestamp,
        nextMemorySampleInSeconds,
        usageDetailsNotSupported,
        usageMemoryPercent,

        storagePersistent,
        quota,
        usageAmount,
        estimateSupported,
        usageUnit,
        quotaUnit,
        usage,
        BytesValueToHR,
    }
})
